module.exports = __webpack_public_path__ + "img/close3.a5a9476e.svg";